import {
    numberWithCommas,
    secondsToHumanReadableDuration,
    metersToKiloMeters,
    getZoomLevelFromDistance,
    unixStringToHumanReadable,
} from '../../common/utils';
import Map from '../../map/Map';
import { DROPDOWN_VARIANTS } from '../../common/constants';
import SegmentDetail from './SegmentDetail';
import {
    PICTURE_TYPE,
    SORTING_ORDER,
    ICONS_LABELS,
} from './SegmentPhotos/constants';

export const transformSegments = (segments) => {
    if (segments && segments.length) {
        return segments.map((segment) => {
            return {
                id: segment.id,
                creatorName: segment.fullName,
                avatar: segment.profilePicture,
                date: unixStringToHumanReadable(segment.startTime),
                litterCount: segment.litterCount
                    ? numberWithCommas(segment.litterCount)
                    : 0,
                distance: segment.distance
                    ? metersToKiloMeters(segment.distance, false)
                    : '0 m',
                mapContent: {
                    MapComponent: Map,
                    center: getMapZoomCenter(segment.location),
                    dataPoints: transformSegmentPolylineData(segment.location),
                    zoom: getZoomLevelFromDistance(segment.distance),
                    dropDownData: PICTURE_TYPE,
                    dropDownVariant: DROPDOWN_VARIANTS.LIST_SIMPLE,
                    ICONS: ICONS_LABELS,
                },
                tagsContent: SegmentDetail,
                zoomLevel: segment.distance
                    ? getZoomLevelFromDistance(segment.distance)
                    : 13.0,
                duration: segment.duration
                    ? secondsToHumanReadableDuration(segment.duration, false)
                    : '0 SEC',
                location:
                    segment.location && segment.location.length
                        ? segment.location.map((location) => {
                              return {
                                  lat: parseFloat(location.lat),
                                  lng: parseFloat(location.long),
                              };
                          })
                        : [],
                title: segment.name,
                segmentIntro: segment.segmentIntro,
                landInfo: segment.landInfo,
                notes: segment.notes || '',
                userId: segment.userId,
                posData: [
                    {
                        x1: 0.5189436170789931,
                        y1: 0.40313633106372976,
                        x2: 0.6093580457899306,
                        y2: 0.46959350020797164,
                    },
                ],
            };
        });
    } else {
        return [];
    }
};

function transformSegmentPolylineData(location) {
    return location && location.length
        ? location.map(({ lat, long }) => {
              return {
                  lat: parseFloat(lat),
                  lng: parseFloat(long),
              };
          })
        : [];
}

function getMapZoomCenter(location) {
    return location && location.length
        ? {
              lat: parseFloat(location[0].lat),
              lng: parseFloat(location[0].long),
          }
        : { lat: 0, lng: 0 };
}

function compare(key, order = 'asc') {
    return function(a, b) {
        // eslint-disable-next-line no-prototype-builtins
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;

        const first =
            a[key].toUpperCase() in SORTING_ORDER
                ? SORTING_ORDER[a[key]]
                : Number.MAX_SAFE_INTEGER;
        const second =
            b[key].toUpperCase() in SORTING_ORDER
                ? SORTING_ORDER[b[key]]
                : Number.MAX_SAFE_INTEGER;

        let result = 0;
        if (first < second) result = -1;
        else if (first > second) result = 1;
        return order === 'desc' ? ~result : result;
    };
}

export const transformPhotos = (photos) => {
    return photos.sort(compare('classification'));
};

export const transformPartners = (partners) => {
    const response = partners.map((partner) => ({
        title: partner.fullName,
        email: partner.email,
        fullName: partner.fullName,
        id: partner.id,
        username: partner.username,
    }));
    if (response.length) {
        return [{ id: 'ALL', title: 'ALL', fullName: 'ALL' }, ...response];
    } else return [];
};
